class DisplayWhenBelowDirective {
    constructor($window, $timeout, CheckoutService) {
        this.restrict = 'A';
        this.$window = $window;
        this.$timeout = $timeout;
        this.element = null;
        this.relativeElementId = null;
        this.elementVisible = false;
        this.attrs = null;
        this.service = CheckoutService;
    }

    get relativeElementOnScreen() {
        const relativeElement = document.getElementById(this.attrs.displayWhenBelow);
        if (!relativeElement) {
            return false;
        }

        return document.getElementById(this.attrs.displayWhenBelow).getBoundingClientRect().top - this.$window.outerHeight < 0
    }

    link(scope, element, attrs, controllers) {
        this.attrs = attrs;

        const scroll = () => {
            if(this.elementVisible && this.relativeElementOnScreen) {
                console.log('@ hide');
                element.removeClass('visible');
                this.elementVisible = false;
            } else if(!this.elementVisible && !this.relativeElementOnScreen) {
                console.log('@ show');
                element.addClass('visible');
                this.elementVisible = true;
            }
        };

        this.$timeout(() => {
            scroll();
        }, 100);

        const onChange = (event) => {
            scroll();
        }

        angular.element(this.$window).on('resize', onChange);
        angular.element(this.$window).on('scroll', onChange);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', onChange);
            angular.element(this.$window).off('scroll', onChange);
        });
    }


    static directiveFactory($window, $timeout) {
        'ngInject';
        return new DisplayWhenBelowDirective($window, $timeout);
    }
}

export default DisplayWhenBelowDirective;
